<template>
  <!-- Checkboxes -->
  <div v-if="isCheckbox(input)">
    <md-checkbox :disabled="!edit" v-model="model">{{input.label}}</md-checkbox>
    <span class="md-helper-text">{{input.hint}}</span>
  </div>
  <div v-else>
    <md-field>
      <label>{{input.label}}</label>
      <md-select v-if="input.options" v-model="model">
        <!-- Dropdown list -->
        <md-option
          :disabled="!edit"
          :required="input.required"
          v-for="item in input.options"
          :key="item.value"
          :value="item.value"
        >{{item.display || item.value}}</md-option>
      </md-select>
      <!-- Mutliline input -->
      <md-textarea
        v-else-if="input.multiline"
        class="md-primary"
        :disabled="!edit"
        :required="input.required"
        v-model="model"
      />
      <!-- Otherwise, show input with specific type -->
      <md-input
        v-else
        class="md-primary"
        :disabled="!edit"
        :required="input.required"
        :type="input.type"
        v-model="model"
      />
      <span class="md-helper-text">{{input.hint}}</span>
    </md-field>
  </div>
</template>

<script>
import { DialogInputTypes } from "@/js/helper";
import Vue from "vue";

export default {
  name: "EditField",
  props: {
    edit: Boolean,
    input: Object
  },
  methods: {
    isCheckbox(input) {
      return this.input.type === DialogInputTypes.bool;
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.input.value = value;
        this.value = value;
      }
    }
  },
  data: function() {
    return { value: this.input.value };
  }
};
</script>

<style lang="scss" scoped>
.md-checkbox {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// editField.vue?7b25fe76